/** Freigegebene Farbnamen, keine beliebigen Bildschirmfarben. IDs stehen auch in ShopOrderRules.kt. */
export const FRAME_TERRAIN_COLORS = [
  { id: 'ash-grey', name: 'Steingrau', hex: '#9B9EA0', filament: 'PLA Matte Ash Grey' },
  { id: 'desert-tan', name: 'Sand', hex: '#E8DBB7', filament: 'PLA Matte Desert Tan' },
  { id: 'dark-green', name: 'Waldgrün', hex: '#68724D', filament: 'PLA Matte Dark Green' },
  { id: 'bone-white', name: 'Knochenweiß', hex: '#CBC6B8', filament: 'PLA Matte Bone White' },
] as const;
export const FRAME_ROUTE_COLORS = [
  { id: 'scarlet-red', name: 'Rot', hex: '#DE4343', filament: 'PLA Matte Scarlet Red' },
  { id: 'charcoal', name: 'Anthrazit', hex: '#252629', filament: 'PLA Matte Charcoal' },
  { id: 'ivory-white', name: 'Weiß', hex: '#FFFFFF', filament: 'PLA Matte Ivory White' },
] as const;
export const FRAME_BORDER_COLORS = [
  { id: 'black', name: 'Schwarz', hex: '#19191B' },
  { id: 'white', name: 'Weiß', hex: '#EFEEE9' },
] as const;
export interface FrameColors {
  terrain: typeof FRAME_TERRAIN_COLORS[number]['id'];
  route: typeof FRAME_ROUTE_COLORS[number]['id'];
  frame: typeof FRAME_BORDER_COLORS[number]['id'];
}
export const DEFAULT_FRAME_COLORS: FrameColors = { terrain: 'ash-grey', route: 'scarlet-red', frame: 'black' };
export const FRAME_BACKGROUND = '#F5F5F2';
export const FRAME_INK = '#252629';
export function validFrameColors(value: unknown): value is FrameColors {
  if (!value || typeof value !== 'object') return false;
  const c = value as FrameColors;
  return FRAME_TERRAIN_COLORS.some(v => v.id === c.terrain) && FRAME_ROUTE_COLORS.some(v => v.id === c.route)
    && FRAME_BORDER_COLORS.some(v => v.id === c.frame);
}
export function frameColorHex(colors: FrameColors) {
  return {
    terrain: FRAME_TERRAIN_COLORS.find(c => c.id === colors.terrain)!.hex,
    route: FRAME_ROUTE_COLORS.find(c => c.id === colors.route)!.hex,
    frame: FRAME_BORDER_COLORS.find(c => c.id === colors.frame)!.hex,
  };
}
